module.exports = __webpack_public_path__ + "media/images/flags/32/Syria-6597e79a441292540c72bb866e99dca0.png";